import { useContext } from "react";
import { ConfigContext, ConfigContextInterface } from "_core/context/config";

export const useConfig = () => {
  const configContext = useContext<ConfigContextInterface>(ConfigContext);

  if (!configContext) {
    throw new Error(
      "Config context is undefined. You are calling useConfig() outside of the application"
    );
  }

  return configContext.config!;
};
